export function renderString(string?: string | null | undefined): string {
  return string || "";
}
